import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: ''
  });
  
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Criar mensagem personalizada baseada no interesse selecionado
    let message = `Olá, sou ${formData.name}. `;
    
    switch(formData.interest) {
      case 'session':
        message += 'Gostaria de agendar uma sessão terapêutica.';
        break;
      case 'community':
        message += 'Gostaria de participar da Comunidade Seu Poder.';
        break;
      case 'both':
        message += 'Tenho interesse em agendar uma sessão terapêutica e também em participar da Comunidade Seu Poder.';
        break;
      default:
        message += 'Gostaria de saber mais sobre seu trabalho.';
    }
    
    message += ` Meu e-mail é ${formData.email} e meu telefone é ${formData.phone}.`;
    
    // Criar link do WhatsApp com o número internacional e a mensagem
    const phoneNumber = "5537998630380"; // Adicionando o código do país (55) antes do número
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    // Abrir o WhatsApp em uma nova aba
    window.open(whatsappLink, '_blank');
    
    // Redirecionar para a página de agradecimento após um pequeno delay
    setTimeout(() => {
      window.location.href = '/obrigado';
    }, 500);
  };

  return (
    <section id="form" className="py-20 bg-light-gray">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 relative text-center">
            Comece sua jornada
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-accent-red mt-2"></span>
          </h2>
          
          <div className="bg-primary-white p-8 shadow-lg">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Nome completo</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-accent-red focus:border-transparent"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">E-mail</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-accent-red focus:border-transparent"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Telefone / WhatsApp</label>
                <input 
                  type="tel" 
                  id="phone" 
                  name="phone" 
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-accent-red focus:border-transparent"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="interest" className="block text-sm font-medium text-gray-700 mb-1">Tenho interesse em:</label>
                <select 
                  id="interest" 
                  name="interest" 
                  value={formData.interest}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-accent-red focus:border-transparent"
                  required
                >
                  <option value="">Selecione uma opção</option>
                  <option value="session">Agendar uma sessão terapêutica</option>
                  <option value="community">Participar da Comunidade Seu Poder</option>
                  <option value="both">Ambas as opções</option>
                </select>
              </div>
              
              <div className="pt-4">
                <button 
                  type="submit" 
                  className="w-full bg-accent-red text-primary-white py-4 px-6 text-lg font-semibold uppercase tracking-wider hover:bg-red-800 transition-colors"
                >
                  Começar minha jornada
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
